import React from "react";
import classNames from "classnames";
import { IConveyorBoxItemUI } from "../../../../lib/interfaces/ConveyorBox/IConveyorBox";
import styles from "./parts.module.css";

const bagColor = (index: number) => {
  let i = index;
  const colors = [
    "#6B5B95", // Purple Haze
    "#88B04B", // Soft Green
    "#F7CAC9", // Pale Pink
    "#92A8D1", // Powder Blue
    "#955251", // Rosewood
    "#B565A7", // Orchid
    "#009B77", // Teal
    "#DD4124", // Flame
    "#45B8AC", // Aqua Mint
    "#EFC050", // Goldenrod
    "#5B5EA6", // Indigo
    "#9B2335", // Cranberry
    "#DFCFBE", // Sand
    "#BC243C", // Deep Red
  ];
  if (index > colors.length - 1) {
    i = 0;
  }

  return colors[i];
};

type Props = {
  title: string;
  bundleId?: number;
  bundleIndex?: number;
  attributes: IConveyorBoxItemUI["attributes"];
};

const BoxItemHeader = ({ title, attributes, bundleId = -1, bundleIndex = -1 }: Props) => {
  return (
    <div
      className={classNames(styles["article-name"], {
        [styles["article-name--short"]]: bundleId > 1,
      })}
    >
      <h3 style={{ marginBottom: "0px" }}>{title}</h3>

      <i
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "rgb(255, 255, 255, 0.8)",
        }}
      >
        {bundleId > -1 && `Ingår i påse ${bundleId}`}
        {bundleId > -1 && (
          <div
            style={{
              height: "17px",
              width: "15px",
              marginLeft: "10px",
              borderRadius: "999px",
              backgroundColor: bagColor(bundleIndex),
            }}
          />
        )}
      </i>

      {attributes.includes("NARC") && (
        <div>
          <span
            style={{
              color: "red",
              float: "left",
              marginTop: "50px",
              position: "absolute",
              zIndex: 3,
            }}
          >
            <b style={{ fontSize: "1.5em" }}>Nark-vara!</b>
          </span>
        </div>
      )}
    </div>
  );
};

export default BoxItemHeader;
